import PropTypes from "prop-types";
import React from "react";
import { Button, ButtonToolbar, Form, FormControl } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";

import genericTranslations from "../../../utils/genericTranslations.js";
import { validateEmailAddress } from "../../../utils/utils.js";

const messages = defineMessages({
  name: {
    id: "modules.EmailEstablishment.components.EstablishmentForm.name",
    description: "Email Establishment name label",
    defaultMessage: "Establishment name",
  },
  code: {
    id: "modules.EmailEstablishment.components.EstablishmentForm.code",
    description: "Email Establishment code label.",
    defaultMessage: "Establishment code",
  },
  email: {
    id: "modules.EmailEstablishment.components.EstablishmentForm.email",
    description: "Email Establishment label.",
    defaultMessage: "Establishment email-address",
  },
});

const EstablishmentForm = ({
  handleChange,
  handleSubmit,
  errors,
  isSubmitting,
  values,
}) => (
  <Form onSubmit={handleSubmit}>
    <Form.Group controlId="principalId" className="mb-3">
      <Form.Label>
        <FormattedMessage {...messages.code} />
      </Form.Label>
      <FormControl
        type="text"
        value={values.principalId}
        disabled
        isInvalid={!values.principalId}
      />
      <Form.Control.Feedback type="invalid">
        {errors.principalId}
      </Form.Control.Feedback>
    </Form.Group>

    <Form.Group controlId="name" className="mb-3">
      <Form.Label>
        <FormattedMessage {...messages.name} />
      </Form.Label>
      <FormControl
        type="text"
        value={values.name}
        disabled
        isInvalid={!values.name}
      />
      <Form.Control.Feedback type="invalid">
        {errors.name}
      </Form.Control.Feedback>
    </Form.Group>

    <Form.Group controlId="emailAddress" className="mb-3">
      <Form.Label>
        <FormattedMessage {...messages.email} />
      </Form.Label>
      <FormControl
        type="text"
        autoComplete="off"
        value={values.emailAddress}
        onChange={handleChange}
        isInvalid={
          !values.emailAddress || validateEmailAddress(values.emailAddress)
        }
      />
      <Form.Control.Feedback type="invalid">
        {errors.emailAddress}
      </Form.Control.Feedback>
    </Form.Group>

    <hr />

    <Form.Group controlId="formActions" className="mb-3">
      <ButtonToolbar>
        <Button
          type="submit"
          variant="primary"
          className="me-2"
          disabled={isSubmitting || Object.keys(errors).length > 0}
        >
          <FormattedMessage {...genericTranslations.save} />
        </Button>
      </ButtonToolbar>
    </Form.Group>
  </Form>
);

EstablishmentForm.propTypes = {
  // Own props
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,

  errors: PropTypes.shape({
    id: PropTypes.string,
    principalId: PropTypes.string,
    name: PropTypes.string,
    emailAddress: PropTypes.string,
  }),

  values: PropTypes.shape({
    id: PropTypes.string,
    principalId: PropTypes.string,
    name: PropTypes.string,
    emailAddress: PropTypes.string,
  }).isRequired,
};

export default EstablishmentForm;
